<div class="row">
    <div class="col-sm-8 col-12">
        <h1>Pesquisa PAC</h1>
    </div>
</div>

<form>
    <div class="card">
        <div class="card-body">
            <div class="row" *ngIf="!exibePesquisaAvancada">
                <div class="col-sm-12 col-12">
                    <h6 class="mb-0">Critério</h6>
                    <input class="form-control col-12" [(ngModel)]="criterio" name="criterio" autofocus>
                </div>
            </div>

            <div class="row" *ngIf="exibePesquisaAvancada">
                <div class="col-sm-2 col-12">
                    <h6 class="mb-0">Proposta</h6>
                    <input class="form-control col-12" [(ngModel)]="criterioProposta" name="criterioProposta">
                </div>
                <div class="col-sm-2 col-12">
                    <h6 class="mb-0">Ano</h6>
                    <input class="form-control col-12" [(ngModel)]="criterioAno" name="criterioAno">
                </div>
                <div class="col-sm-2 col-12">
                    <h6 class="mb-0">PAC</h6>
                    <input class="form-control col-12" [(ngModel)]="criterioPac" name="criterioPac">
                </div>
                <div class="col-sm-6 col-12">
                    <h6 class="mb-0">Comprador / Razão Social</h6>
                    <input class="form-control col-12" [(ngModel)]="criterioComprador" name="criterioComprador">
                </div>

            </div>
        </div>
    </div>

    <div class="row">
        <div class="d-flex col-12 justify-content-end">
            <button class="btn" (click)="alternarPesquisa()" type="button">
                <i class="fa fa-search-minus me-1" aria-hidden="true" *ngIf="exibePesquisaAvancada"></i>
                <i class="fa fa-search-plus me-1" aria-hidden="true" *ngIf="!exibePesquisaAvancada"></i>
                {{ exibePesquisaAvancada ? 'Pesquisa Simplificada' : 'Pesquisa Avançada'}}
            </button>

            <button class="btn btn-primary" (click)="pesquisar()" type="submit">
                <i class="fa fa-search me-1" aria-hidden="true"></i>
                Pesquisar
            </button>
        </div>
    </div>
</form>

<br>

<p *ngIf="msg">{{msg}}</p>

<div class="table-responsive" *ngIf="!msg">
    <table class="table table-hover">
        <thead>
        <tr>
            <th scope="col">Proposta</th>
            <th scope="col">Ano</th>
            <th scope="col">PAC</th>
            <th scope="col">Comprador</th>
            <th scope="col">Razão Social</th>
        </tr>
        </thead>
        <tbody>

        <!-- tr class="clickable" *ngFor="let pac of pacs" (click)="onVisualizarClick(pac)" -->
        <tr class="clickable" *ngFor="let pac of pacs" (click)="onVisualizarClick(pac)">
            <td>{{pac?.propostaNumero}}</td>
            <td>{{pac?.propostaAno}}</td>
            <td>{{pac?.numeroPacStr | bnMask:'99.999-9'}}</td> <!-- 00.799-4 -->
            <!--td>{{pac?.compradorCnpjCpf | bnMask:'CNPJCPF'}} - {{pac?.compradorNome}}</td-->
            <td>{{pac?.compradorCnpjCpf | bnMask:'CNPJCPF'}}</td>
            <td>{{pac?.compradorNome}}</td>
        </tr>

        </tbody>
        <tfoot>
        <tr>
            <td colspan="5">Exibindo {{pacs.length}} registros</td>
        </tr>
        </tfoot>
    </table>
</div>

<!--
<h5>PACs</h5>
{{pacs | json}}
-->
